import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";
import * as api from "apis/pushNotificationTemplate";

//Query untuk get all push notification templates
export const usePushNotificationTemplates = (options = {}) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["pushNotificationTemplates"],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getPushNotificationTemplates();
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};

//Query untuk get detail push notification template
export const usePushNotificationTemplate = ({ payload = {} }, options = {}) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["pushNotificationTemplate", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getPushNotificationTemplate(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};

// Query untuk edit push notification template
export const useEditPushNotificationTemplate = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.editPushNotificationTemplate(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk revert push notification template
export const useRevertPushNotificationTemplate = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.revertPushNotificationTemplate(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
